"use client";
import React, { useState } from 'react';
import clsx from "clsx";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import Markdown from "@/components/atoms/Markdown";

const ReferralAdvantage = ({ Title, Subtitle, ImageList, imagesPerPage = 2, isReferralPage = false, textCenter = true }) => {
  const [currentPage, setCurrentPage] = useState(0);

  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const slides = [];
  for (let i = 0; i < ImageList.length; i += imagesPerPage) {
    slides.push(ImageList.slice(i, i + imagesPerPage));
  }

  const totalPagesMobile = slides.length;

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    setTouchEnd(e.changedTouches[0].clientX);
    if (touchStart - touchEnd > 10) {
      setCurrentPage((prevPage) => (prevPage + 1) % totalPagesMobile);
    }
    if (touchStart - touchEnd < -10) {
      setCurrentPage((prevPage) => (prevPage - 1 + totalPagesMobile) % totalPagesMobile);
    }
  };

  return (
    <div className="py-9 ">
      <div className="container font-raleway">
        <div className="px-5 md:p-6">
          <div className="mb-8 flex flex-col sm:flex-col md:flex-col lg:flex-row justify-between">
            <h2 className="lg:text-2xl text-[24px] md:text-xl font-raleway color-[#1a325d]  lg:text-3xl text-[#1a325d]">{Title?.text}</h2>
            {Subtitle?.enabled && (
              <p 
              className="text-[14px] lg:text-[0.8333rem] text-[#666666] mt-2 " 
              dangerouslySetInnerHTML={{ __html: Subtitle?.text }}
            />
            )}
          </div>

          {/* Mobile: 2 Items per Slide */}
          <div className="border-t border-gray-300 mt-8 pt-10">
            <div
              className="overflow-hidden lg:hidden"
              onTouchStart={handleTouchStart}
              onTouchEnd={handleTouchEnd}
            >
              <div
                className="flex transition-transform duration-300 ease-in-out"
                style={{ transform: `translateX(-${currentPage * 100}%)` }}
              >
                {slides.map((group, groupIndex) => (
                  <div key={groupIndex} className="flex-none w-full">
                    {group.map((item, index) => {
                      const img = strapiSingleAttribute(item.Image.source || item.Image);
                      return (
                        <div key={index} className="mb-12 flex flex-col items-center">
                          <div className="h-16 mb-5 relative">
                            <img
                              src={img?.url}
                              alt={img?.alternativeText || ""}
                              className="h-[54px]"
                              loading="lazy"
                            />
                          </div>
                          <h3 className="text-[#1A325D] text-l text-center font-medium leading-tight mt-2 ">
                            <Markdown>{item.Title.text}</Markdown>
                          </h3>
                          {item.Subtitle.enabled && (
                            <p className="text-[12px]  text-[#666] text-center mt-2">{item.Subtitle.text}</p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>

            {/* Pagination for mobile */}
            <div className="flex justify-center gap-2 mt-8 mb-6 lg:hidden">
              {Array.from({ length: totalPagesMobile }).map((_, pageIndex) => (
                <div
                  key={pageIndex}
                  className={`h-3 w-3 rounded-full cursor-pointer ${
                    currentPage === pageIndex
                      ? "bg-[#1A325D]"
                      : "bg-white border border-[#1A325D]"
                  }`}
                  onClick={() => setCurrentPage(pageIndex)}
                ></div>
              ))}
            </div>
          </div> 

          {/* Desktop: Grid layout */}
          <div className="hidden lg:grid lg:grid-cols-5 lg:gap-x-20 gap-y-12 lg:gap-y-10">
            {ImageList.map((item, index) => {
              const img = strapiSingleAttribute(item.Image.source || item.Image);
              return (
                   <div key={index} className={clsx("flex flex-col items-start")}>
                  <div className="h-[3.2rem] w-[3.2rem] mb-5 relative">
                    <img
                      src={img?.url}
                      alt={img?.alternativeText || ""}
                      className="h-full"
                      loading="lazy"
                    />
                  </div>
                  <h3 className="text-[#1A325D] font-semibold leading-tight mt-2 text-[1rem]">
                    <Markdown>{item.Title.text}</Markdown>
                  </h3>
                  {item.Subtitle.enabled && (
                    <p className="text-[#666]  mt-2 text-[0.75rem]">{item.Subtitle.text}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralAdvantage;
